export default function Footer() {
    return (
      <footer className="text-center text-sm text-gray-500 py-4 border-t mt-auto">
        © {new Date().getFullYear()} NPC ResidentPass. All rights reserved.
      </footer>
    );
  }
  